import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/home-main.svg";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";

function Home() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row className="align-items-center hero-shell">
            <Col md={7} className="home-header">
              <div className="hero-panel hero-panel-left">
              <p className="project-kicker">Software Engineer</p>
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Hi There!{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>

              <h1 className="heading-name">
                I'M
                <strong className="main-name"> Saurav Jaiswal</strong>
              </h1>

              <p className="hero-description">
                Building distributed systems, scalable backend platforms, and AI-enabled
                products with a bias for shipping practical, scalable, and efficient software.
              </p>

              <div className="type-shell">
                <Type />
              </div>
              </div>
            </Col>

            <Col md={5} className="hero-visual-wrap" style={{ paddingBottom: 20 }}>
              <img
                src={homeLogo}
                alt="home pic"
                className="img-fluid hero-visual"
                style={{ maxHeight: "450px" }}
              />
            </Col>
          </Row>
        </Container>
      </Container>
      <Home2 />
    </section>
  );
}

export default Home;
